import P from "layouts/wrapper/P";
import style from "./Main4.module.scss";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
// import cartoon1 from "resources/puffu/cartoon/cartoon1.png"
// import cartoon2 from "resources/puffu/cartoon/cartoon2.png"
// import cartoon3 from "resources/puffu/cartoon/cartoon3.png"
// import cartoon4 from "resources/puffu/cartoon/cartoon4.png"
// import cartoon5 from "resources/puffu/cartoon/cartoon5.png"
// import cartoon6 from "resources/puffu/cartoon/cartoon6.png"
import guide1 from "resources/puffu/icon/guide1-1.png";
import guide2 from "resources/puffu/icon/guide1-2.png";
import guide3 from "resources/puffu/icon/guide1-3.png";
import guide4 from "resources/puffu/icon/guide1-4.png";
import guide5 from "resources/puffu/icon/guide1-5.png";
import guide6 from "resources/puffu/icon/guide1-6.png";
import rightIcon from "resources/puffu/icon/right.png";
// import cartoonWeb from "resources/puffu/cartoon/cartoonWeb.png";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useState } from "react";
import Container from "layouts/container/Container";
import Center from "layouts/wrapper/Center";
import Inline from "layouts/wrapper/Inline";
import Dummy from "layouts/wrapper/Dummy";
import guideImg from "resources/puffu/guideImg.png";


function Section6B(props) {
    const { isMobile } = useContext(BrowserDetectContext);

    const [guide, setGuide] = useState([
        {
            index: "01",
            img: guide1,
            title: "가맹상담"
        },
        {
            index: "02",
            img: guide2,
            title: "상권분석",
            noneRight: false
        },
        {
            index: "03",
            img: guide3,
            title: "가맹계약체결"
        },
        {
            index: "04",
            img: guide4,
            title: "교육 및 오픈준비",
            noneRight: isMobile ? true : false
        },
        {
            index: "05",
            img: guide5,
            title: "시설공사",
            margin: "60px 0 0 0 "
        },
        {
            index: "06",
            img: guide6,
            title: "매장오픈",
            margin: "60px 0 0 0 ",
            noneRight: isMobile ? true : false

        }
        ,
        {
            index: "07",
            title: "매장오픈",
            puffu: true,
            margin: "60px 0 0 0 "
        }
    ]);
    const Box = (props) => {
        const { data } = props;
        const [isSmallScreen, setIsSmallScreen] = useState(false);

        useEffect(() => {
            const mediaQuery = window.matchMedia("(max-width: 980px)");

            const handleMediaQueryChange = (e) => {
                setIsSmallScreen(e.matches);
            };

            mediaQuery.addListener(handleMediaQueryChange);
            handleMediaQueryChange(mediaQuery);

            return () => {
                mediaQuery.removeListener(handleMediaQueryChange);
            };
        }, []);

        const shouldHideIcon = data.index === "04" ? isSmallScreen : !data.noneRight;
        return (
            data.puffu
                ?
                isMobile
                    ?
                    <>
                        <div style={{
                            backgroundColor: "var(--main-color)",
                            display: "flex",
                            flexDirection: "column",
                            flex: "1 1 40%",
                            borderRadius: "12px",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "10px",
                            // height: "130px",
                            height: "16%",
                            // margin: "0 8px 0 0"
                            position: "relative"
                        }}>
                            <p style={{
                                fontSize: "clamp(14px, 5vw, 18px",
                                fontWeight: "bold",
                                color: "white",
                                position: "absolute",
                                top: "2vw",
                                left: "3vw",
                                textAlign: "left",
                            }}>07</p>
                            <FlexChild height="fit-content">
                                <P weight={"bold"} size={"clamp(22px, 4vw, 38px"} color={"white"}>PUFFU</P>
                            </FlexChild>
                        </div>
                        {/* <Dummy width={"1px"} /> */}
                    </>
                    :
                    <>
                        <div className={style.limeBox}>
                            <FlexChild>
                                <Center width={shouldHideIcon ? "100%" : "90%"}>
                                    <P size={24} weight={"bold"} color={"white"} textAlign={"left"}>07</P>
                                </Center>
                            </FlexChild>
                            <FlexChild>
                                <Center width={"100%"}>
                                    <P size={42} font={"gmarketSansBold"} color={"white"}>PUFFU</P>
                                </Center>
                            </FlexChild>
                        </div>
                        <div className={style.limeBoxDummy} />
                    </>
                :
                isMobile
                    ?
                    <div style={{ display: "flex", flex: "1 1 35%", gap: "5px", justifyContent: "flex-start" }}>
                        <div style={{
                            backgroundColor: "white",
                            border: "1.5px solid var(--main-color)",
                            display: "flex",
                            width: "100%",
                            // maxWidth: "90px",
                            // height: "130px",
                            borderRadius: "12px",
                            padding: "10px 0",
                            flexDirection: "column",
                            position: "relative"
                        }}>
                            <p style={{
                                fontSize: "clamp(14px, 5vw, 18px",
                                fontWeight: "bold",
                                position: "absolute",
                                top: "2vw",
                                left: "3vw",
                                textAlign: "left",
                            }}>{data.index}</p>
                            <VerticalFlex gap={10} height="fit-content" justifyContent="center">
                                <FlexChild height="fit-content" padding={!isMobile && "10px 0 0 0"}>
                                    <img src={data.img} height={"30px"} />
                                </FlexChild>
                                <FlexChild height="fit-content">
                                    <P font={"PretendardBold"} weight={"bold"} size={"clamp(14px, 3.5vw, 18px"}>{data.title}</P>
                                </FlexChild>
                            </VerticalFlex>
                        </div>
                        {
                            isMobile
                                ?
                                !data.noneRight &&
                                <div style={{ position: "absolute", right: "50%", padding: "60px 0 0 13px", width: "25px", display: "none" }}>
                                    <img src={rightIcon} width={"100%"} />
                                </div>
                                // null
                                :
                                !data.noneRight &&
                                <div style={{ width: "10%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <img src={rightIcon} width={"100%"} />
                                </div>

                        }
                    </div>
                    :
                    <div style={{ display: "flex", flex: "1 1 23%", gap: "30px", justifyContent: "flex-start" }}>
                        <div className={style.box} style={{ margin: data.margin }}>
                            <VerticalFlex>
                                <FlexChild padding={"0 0 15px 0"}>
                                    <Center width={"100%"}>
                                        <P textAlign={"left"} weight={"bold"} size={24}>{data.index}</P>
                                    </Center>
                                </FlexChild>
                                <FlexChild padding={"0 0 20px 0"}>
                                    <img src={data.img} height={"48px"} style={{ filter: "" }} />
                                </FlexChild>
                                <FlexChild>
                                    <P size={22}>{data.title}</P>
                                </FlexChild>
                            </VerticalFlex>
                        </div>
                        {
                            shouldHideIcon &&
                            <div
                                style={{
                                    width: "10%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    margin: "60px 0 0 0 "
                                }}
                                className={style.rightIconArea}
                            >
                                <img src={rightIcon} width={"100%"} style={{ filter: "invert(100%)" }} />
                            </div>
                        }
                    </div>
        );
    }
    return (
        <Container>
            <Container maxWidth={1200}>
                <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <VerticalFlex gap={40} height={"fit-content"}>
                        {
                            isMobile
                                ?
                                <FlexChild>
                                    <VerticalFlex>
                                        <FlexChild padding={"0 0 2vh 0"}>
                                            <Center width={"100%"}>
                                                <P size={"clamp(20px, 5vw, 24px)"} weight={500} color={"var(--point-color)"}>안정적인 수익성과 경쟁력</P>
                                                <P font={"gmarketSansBold"} size={"clamp(28px, 7vw, 36px)"} lineHeight={'1.2'} padding={"10px"} weight={"bold"} color={"black"}>푸푸 창업 절차안내</P>
                                            </Center>
                                        </FlexChild>
                                        <FlexChild maxWidth={isMobile && "450px"} height={"60vh"}>
                                            <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "10px", width: isMobile ? "88%" : "100%", height: "100%" }}>
                                                {
                                                    guide && guide.map((row, index) => {
                                                        return (
                                                            <Box data={row} key={index} />
                                                        );

                                                    })
                                                }
                                            </div>
                                        </FlexChild>
                                        <FlexChild alignItems={"flex-start"} width={"80%"}>
                                            <Center width={"100%"} >
                                                <P size={"clamp(12px, 2vw, 15px"} color={"#8b8b8b"} wordBreak={"keep-all"} lineHeight={"1.5"}>당사는 귀하가 점포를 선정하는데 도움을 주기 위하여 설치장소, 통행인의 수, 지역의 특징, 업종의 특성에 따른  매출 성향 등을 귀하에게 조언할 수 있습니다</P>
                                            </Center>
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild>
                                :
                                <FlexChild padding={"0 0 100px 0"}>
                                    <VerticalFlex gap={20}>
                                        <FlexChild>
                                            <Center width={"100%"}>
                                                <P size={"clamp(18px, 1.8vw, 24px)"} weight={500} color={"var(--point-color)"} padding={"0 0 10px 0"}>안정적인 수익성과 경쟁력</P>
                                                <P font={"gmarketSansBold"} size={"clamp(28px, 2.5vw, 40px)"} lineHeight={'1.2'} padding={"10px"} weight={"bold"} color={"black"}>푸푸 창업 절차안내</P>
                                                <Dummy height={"clamp(10px, 1vw, 30px"} />
                                            </Center>
                                        </FlexChild>
                                        {/* <FlexChild>
                                            <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "25px", width: "100%", height: "100%", padding: "0 20px", marginLeft: "70px" }}>
                                                {
                                                    guide && guide.map((row, index) => {
                                                        return (
                                                            <Box data={row} />
                                                        );
                                                    })
                                                }
                                            </div>
                                        </FlexChild>
                                        <FlexChild alignItems={"flex-start"}>
                                            <Dummy width={"100%"} height={"60px"} />
                                            <Center width={"90%"} >
                                                <P size={16} textAlign={"left"} color={"#505050"}> 당사는 귀하가 점포를 선정하는데 도움을 주기 위하여 설치장소, 통행인의 수, </P>
                                                <Dummy height={"15px"} />
                                                <P size={16} textAlign={"left"} color={"#505050"}> 지역의 특징, 업종의 특성에 따른  매출 성향 등을 귀하에게 조언할 수 있습니다</P>
                                            </Center>
                                        </FlexChild> */}
                                        <FlexChild>
                                            <img src={guideImg} className={style.Procedure_img} style={{ minWidth: "600px" }} />
                                        </FlexChild>
                                    </VerticalFlex>
                                    {/* <img src={cartoonWeb} width={"100%"} /> */}



                                </FlexChild>
                        }
                    </VerticalFlex>
                    {/* <div style={{ position: "absolute", width: "100vw", height: "100dvh" }}>
                        <div className={style.bannerContainer} style={{height: "50px"}}>
                            <div className={style.bannerText}>
                                푸푸를 고민중이라면 언제든 연락하세요! 가맹문의 070-4943-2597
                            </div>
                            <div className={style.bannerText}>
                                푸푸를 고민중이라면 언제든 연락하세요! 가맹문의 070-4943-2597
                            </div>
                            <div className={style.bannerText}>
                                푸푸를 고민중이라면 언제든 연락하세요! 가맹문의 070-4943-2597
                            </div>
                            <div className={style.bannerText}>
                                푸푸를 고민중이라면 언제든 연락하세요! 가맹문의 070-4943-2597
                            </div>
                            <div className={style.bannerText}>
                                푸푸를 고민중이라면 언제든 연락하세요! 가맹문의 070-4943-2597
                            </div>
                            <div className={style.bannerText}>
                                푸푸를 고민중이라면 언제든 연락하세요! 가맹문의 070-4943-2597
                            </div>
                        </div>
                    </div> */}
                </div>
            </Container>
                
        </Container>
    );
}

export default Section6B;